<p-splitButton
  styleClass="p-button-text mr-2 mb-2"
  [label]="label"
  [icon]="icon"
  (onClick)="navigateToRouterLink()"
  [model]="model"
></p-splitButton>
